/// <reference types="@types/googlemaps" />
import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IconSelect, PillColorType, SelectItem } from '@eg/ui';
import { enumToSelectItemArray } from '@railmybox/shared/util';

@UntilDestroy()
@Component({
  selector: 'railmybox-components',
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.scss'],
  standalone: false,
})
export class ComponentsComponent {
  radioSelectItems: SelectItem[] = [
    { label: 'item 1', value: 'i1', disabled: false },
    { label: 'item 2', value: 'i2', disabled: false },
    { label: 'item disabled', value: 'i3', disabled: true },
  ];

  tileSelectItems: SelectItem[] = [
    { label: 'item 1', value: 'i1', disabled: false },
    { label: 'item 2', value: 'i2', disabled: false },
    { label: 'item disabled', value: 'i3', disabled: true },
  ];

  iconSelectItems: IconSelect[] = [
    { iconName: 'trip_drop', value: true },
    { iconName: 'trip_eco', value: false },
  ];

  pillsColors: PillColorType = {
    grey: 'grey',
    lightOrange: 'lightOrange',
    orange: 'orange',
    lightGreen: 'lightGreen',
    green: 'green',
    blue: 'blue',
    lightRed: 'lightRed',
    red: 'red',
    selected: 'selected',
    inactive: 'inactive',
    'light-green': 'light-green',
    'light-orange': 'light-orange',
    'light-red': 'light-red',
  };
  pillNames = enumToSelectItemArray(this.pillsColors, '', '');
}
